// import Debug from "debug";
import { Action, Dispatch, Middleware, Store } from 'redux';
import { createAction, createReducer } from '@reduxjs/toolkit';
import { Entity, getMatchingRule, SecurityAction, SecurityContext } from 'gossamer-unified';
import { getConfig } from '../ancillary/ConfigManager';

// const debug = Debug("gfe/da/ReduxUser");

// like SecurityContext except all fields mandatory
export interface UserState {
  waiting: boolean;
  loggedInUser: SecurityContext | null;
  returnToOnceLoggedIn?: string;
}

type UserStore = Store<{ user: UserState }, Action>;
type LogoutPayload = { returnToOnceLoggedIn?: string };

const configuredUserId = getConfig('user-id');
const configuredRoleId = getConfig('role-id');

const INITIAL_STATE: UserState = {
  waiting: getConfig('login-bypass') !== 'true',
  loggedInUser:
    configuredUserId && configuredRoleId
      ? {
          userId: configuredUserId,
          roleId: configuredRoleId,
          orgPath: getConfig('org-path') || '',
          customInfo: {},
          name: configuredUserId,
          email: undefined,
        }
      : null,
};

const getNameFromEmail = (email: string) => email.substring(0, email.indexOf('@'));

export const login = createAction<SecurityContext>('LOGIN');

export const logout = createAction<LogoutPayload>('LOGOUT');

export const userReducer = createReducer(INITIAL_STATE, (builder) => {
  builder

    .addCase(login, (state, action) => {
      state.loggedInUser = { ...action.payload } as SecurityContext;
      state.waiting = false;
      if (!state.loggedInUser.name && action.payload.email) {
        state.loggedInUser.name = getNameFromEmail(action.payload.email);
      }
    })

    .addCase(logout, (state, action) => {
      state.loggedInUser = null;
      state.waiting = false;
      state.returnToOnceLoggedIn = (action.payload as LogoutPayload).returnToOnceLoggedIn;
    });
});

// Middleware
export const userMiddleware: Middleware<{}, { user: UserState }> = (store) => (next) => (action) => {
  const typedAction = action as { type?: string; payload?: any };
  const result = next(action);
  const returnTo = store.getState().user.returnToOnceLoggedIn;
  if (typedAction.type === login.type && returnTo) {
    console.log({ returnTo });
    window.location.href = returnTo;
  }
  return result;
};

// Selectors
export const selectLoginStateWaiting = (state: { user: UserState }) => state.user.waiting;
export const selectReturnToOnceLoggedIn = (state: { user: UserState }) => state.user.returnToOnceLoggedIn;
export const selectUser = (state: { user: UserState }) => state.user.loggedInUser;

export const isAllowed = (
  entity: Entity<any>,
  action: SecurityAction,
  user: SecurityContext,
  special?: string,
): boolean => {
  try {
    const rule = getMatchingRule(entity, user.roleId, action, special || '');
    return !!rule && rule.access !== 'none';
  } catch (error) {
    return false;
  }
};
